import Component from "../../lib/Component.js";
import clarity from "@microsoft/clarity";

/**
 * @typedef {Object} ClarityProps
 * @property {string} projectId - The Clarity project ID
 * @property {Promise<{analytics: boolean}>} consentPromise - Promise that resolves with consent status
 */

/**
 * Initialize Microsoft Clarity analytics
 * @param {ClarityProps} props
 */
const Clarity = ({ projectId, consentPromise }) => {
  let mounted = false;

  const initClarity = async () => {
    // Only run in production
    if (process.env.NODE_ENV !== "production") {
      console.log("Clarity will not be initialized in non-production environment");
      return;
    }

    const { analytics } = await consentPromise;
    if (!analytics) {
      console.log("Clarity will not be initialized due to cookie consent");
      return;
    }

    try {
      clarity.init(projectId);
      console.log("Clarity initialized with project ID:", projectId);
    } catch (error) {
      console.error("Failed to initialize Clarity:", error);
    }
  };

  return new Component({
    onMount: () => {
      if (mounted) return;
      mounted = true;

      initClarity();
    },
  });
};

export default Clarity;
